import { PageCustomBlock } from '@/components/common/Providers/GraphqlProvider/generated';

import { TitleWrapper } from '../../../views/Home/components';
import { useHomeContext } from '../../../views/Home/HomeProvider/HomeContext';
import styles from './styles.module.css';

const CustomBlock = ({ currentPageCustomBlock }: { currentPageCustomBlock?: PageCustomBlock }) => {
  const {
    home: { customBlock: customBlockContext },
  } = useHomeContext();
  const cusstomBlock = currentPageCustomBlock || customBlockContext;
  if (cusstomBlock?.isDisabled) return null;
  return (
    <div className={'inner-extend mt-10 overflow-hidden'}>
      <div className={'dynamicTableWithBorder mb-8'}>
        <TitleWrapper
          title1={!cusstomBlock?.showTitle ? '' : cusstomBlock?.blockTitle || ''}
          title2={''}
          description={!cusstomBlock?.showDescription ? '' : cusstomBlock?.publicDescription}
        />
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: cusstomBlock?.content || '' }}
        />
      </div>
    </div>
  );
};

export default CustomBlock;

export function CustomBlockSkeleton() {
  return (
    <div className="inner-extend mt-10 overflow-hidden">
      <div className="animate-pulse">
        <div className="mb-2 h-4 w-48 rounded bg-gray-200" />
        <div className="h-40 w-full rounded bg-gray-200" />
      </div>
    </div>
  );
}
